/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { openModalWithAjax, openModalWithContent } from '../../utils/modal-helpers';
//= require v4/file_uploads

window.EvaluationDocuments = {
  _showModal(event) {
    event.preventDefault();
    const url = $(event.currentTarget).attr('href');

    return openModalWithAjax('modalContent', url, {}, {
      success(data) {
        return $(document).on('opened.fndtn.reveal', '[data-reveal]', () => FileUploads.basicInitialize());
      }
    });
  },

  _showModalTiny(event) {
    event.preventDefault();
    const url = $(event.currentTarget).attr('href');

    return openModalWithAjax('modalContentTiny', url, {}, {
      success(data) {
        return $(document).on('opened.fndtn.reveal', '[data-reveal]', () => FileUploads.basicInitialize());
      }
    });
  },

  _showOtherReason() {
    const $reason = $('#reason-div');
    if ($("input[name='document_set[unsubmit_reason]']:checked").val() === 'Other') {
      $reason.removeClass('hide');
      return $reason.find('textarea').attr('disabled', false);
    } else {
      $reason.addClass('hide');
      return $reason.find('textarea').attr('disabled', true);
    }
  },

  _editDocumentLabel(event) {
    event.preventDefault();
    $(event.currentTarget).hide();
    const $form = $('#edit-document-label-form');
    $form.removeClass('hide');
    return $form.find('input').focus();
  },

  _hideForm() {
    const $form = $('#edit-document-label-form');
    return $form.addClass('hide');
  },

  _cancelSave() {
    return this._hideForm();
  },

  _showModalWithContent(modal, content, event) {
    event.preventDefault();
    const modalId = modal.replace('#', '');
    return openModalWithContent(modalId, content);
  },

  initializeIndex() {
    return $(document).on('click', '.add-document-btn, [id^="edit-doc-"]', _.bind(this._showModal, this));
  }
};
